import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ArchivedPageBanner: LoadableType<{
	contentId: string;
	marginStyle?: 'none' | 'bottom' | 'top' | 'both';
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchivedPageBanner" */ '../src/ArchivedPageBannerV2.tsx'
			)
		).ArchivedPageBanner,
});
